import { useTranslation } from 'react-i18next'
import React, { Fragment, useState } from 'react'

import Link from '../../../../components/actions/Link'
import ModalMenu from '../../../../components/navigation/ModalMenu'
import UserCard from './UserCard'
import { useUserActionsList } from '../../../../utils/actions/users/list'

const UserListItem = ({ item }) => {
  const { t } = useTranslation()
  const [actionsOpen, setActionsOpen] = useState(false)
  const options = useUserActionsList(item)

  return (
    <Fragment>
      <Link block onClick={() => setActionsOpen(true)}>
        <UserCard item={item} />
      </Link>
      <ModalMenu t={t} open={actionsOpen} onClose={() => setActionsOpen(false)} options={options} />
    </Fragment>
  )
}

export default UserListItem
